var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0002 9.8V18C13.0002 18.2833 12.9044 18.5208 12.7127 18.7125C12.521 18.9042 12.2835 19 12.0002 19C11.7169 19 11.4794 18.9042 11.2877 18.7125C11.096 18.5208 11.0002 18.2833 11.0002 18V9.8L8.10019 12.7C7.91686 12.8833 7.68353 12.975 7.4002 12.975C7.11686 12.975 6.88353 12.8833 6.7002 12.7C6.51686 12.5167 6.42519 12.2833 6.42519 12C6.42519 11.7167 6.51686 11.4833 6.7002 11.3L11.3002 6.7C11.5002 6.5 11.7335 6.4 12.0002 6.4C12.2669 6.4 12.5002 6.5 12.7002 6.7L17.3002 11.3C17.4835 11.4833 17.5752 11.7167 17.5752 12C17.5752 12.2833 17.4835 12.5167 17.3002 12.7C17.1169 12.8833 16.8835 12.975 16.6002 12.975C16.3169 12.975 16.0835 12.8833 15.9002 12.7L13.0002 9.8Z",
    fill: "#00943D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpArrow);
export default __webpack_public_path__ + "static/media/UpArrow.e606bd0be1becf4e7e794e6def774e58.svg";
export { ForwardRef as ReactComponent };